import * as React from 'react';

import * as styles from './inputWithLabel.scss';
import * as inputStyles from 'components/input/input.scss';

type Props = {
    type?: string;
    id: string;
    name?: string;
    label: string;
    value?: string;
    valid?: boolean;
    className?: string;
    disabled?: boolean;
    hasValidation?: boolean;
    autoComplete?: any;
    required?: boolean;
    maxLength?: number;
    pattern?:boolean;
    onlyNumbers?:boolean
    liftEventInfo?: (event: any) => void;
};

class InputWithLabel extends React.Component<Props, any> {
    public state = {
        value: '',
        maskedValue: '',
        initialState:true
    };

    public componentDidMount() {
        this.setState({ value: this.props.value, initialState: true });
    }

    public componentDidUpdate(prevProps: any) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value });
        }
    }

    private handleOnChange = (event: any): void => {
        const mask = /^(\d{2})(\d{1,3})?(\d{1,3})?(\d{1,3})?$/g;
        const escapedValue = event.target.value.replace(/[^\d]/g, '')
        const maskedValue = escapedValue.replace(mask, (str:string, g1:string,g2:string,g3:string,g4:string)=>{
            return g1 + (g2 ? ' ' + g2 : '' )+ (g3 ? ' ' + g3 : '' ) + (g4 ? ' ' + g4 : '' )
        });
        if(this.props.onlyNumbers){
            const onlyNumbers = /^$|^\d+$/g;
            const valueClear = event.target.value.replace(/[^\d]/g, '');
            event.target.value = onlyNumbers.test(valueClear) ? valueClear : this.state.value;
        }
        this.setState({ value: event.target.value, maskedValue, initialState:false });
        this.liftEventInfo(event);
    };

    private liftEventInfo = (event: any) => {
        if (typeof this.props.liftEventInfo !== 'undefined') {
            this.props.liftEventInfo(event);
        }
    };

    public onFocus = (event: any) => {
        this.liftEventInfo(event);
    };

    public onBlur = (event: any) => {
        this.liftEventInfo(event);
    };

    public getClassNames = (): string => {
        let className = inputStyles.input + ' ';
        const props = this.props;
        if (
            typeof props.valid !== 'undefined' &&
            props.hasValidation &&
            props.valid
        ) {
            className += inputStyles.valid;
        }
        if (
            typeof props.valid !== 'undefined' &&
            props.hasValidation &&
            !props.valid && !this.state.initialState
        ) {
            className += inputStyles.error;
        }
        return className;
    };

    public render() {
        const {
            className,
            type,
            name,
            id,
            autoComplete,
            required,
            disabled,
            maxLength,
            label,
            pattern
        } = this.props;
        const { value, maskedValue } = this.state;

        let wrapperClassName = className || '';
        wrapperClassName += ' ' + styles.wp ;
        return (
            <div className={wrapperClassName}>
                <input
                    id={id}
                    className={this.getClassNames()}
                    type={type}
                    name={name}
                    value={pattern ? maskedValue : value}
                    maxLength={maxLength}
                    autoComplete={autoComplete}
                    required={required}
                    disabled={disabled}
                    placeholder=" "
                    onChange={this.handleOnChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onKeyDown={this.liftEventInfo}
                    onKeyUp={this.liftEventInfo}
                />

                <label htmlFor={id} className={styles.placeholder}>
                    {label}
                </label>
            </div>
        );
    }
}

export default InputWithLabel;
